import ApiRequest from '../../utils/ApiRequest';
import { EnrollmentPackageId, PolicyId } from '../../types/api/primaryKeys/PrimaryKey';
import { PolicyBeneficiary } from '../../types/api/beneficiaries/PolicyBeneficiary';

export async function getBeneficiaryDataForPolicy(policyId: PolicyId, packageId: EnrollmentPackageId) {
    const result = await ApiRequest.get<readonly PolicyBeneficiary[]>(`policies/${policyId}/packages/${packageId}/beneficiaries`);
    return result;
}

export async function updateBeneficiaries(policyId: PolicyId, packageId: EnrollmentPackageId, beneficiaries: readonly PolicyBeneficiary[]) {
    await ApiRequest.put(`policies/${policyId}/packages/${packageId}/beneficiaries`, beneficiaries);
}